const humanizeActionCode = (action) => {
    if (!action || typeof action !== "string") {
        return "";
    }

    return action
        .split("_")
        .map((part) => part.charAt(0) + part.slice(1).toLowerCase())
        .join(" ");
};

export const formatActivityActionLabel = (action, t) => {
    if (!action) {
        return t("notAvailable");
    }

    const key = `upcomingDetails.activityLog.actions.${action}`;
    return t(key, { defaultValue: humanizeActionCode(action) });
};

export const ACTOR_TYPE_TAG_COLORS = {
    ADMIN: "purple",
    USER: "blue",
    AGENT: "cyan",
    SYSTEM: "default",
};

export const formatActorTypeLabel = (actorType, t) => {
    if (!actorType) {
        return t("notAvailable");
    }

    return t(`upcomingDetails.activityLog.actor.${actorType}`, actorType);
};

const readMetadataField = (metadata, keys) => {
    if (!metadata || typeof metadata !== "object") {
        return null;
    }

    const matchedKey = keys.find((key) => {
        const value = metadata[key];
        return value !== null && value !== undefined && String(value).trim() !== "";
    });

    return matchedKey ? String(metadata[matchedKey]).trim() : null;
};

/** Mongo / business user id when the API stores it on the log or in metadata. */
export const getActivityLogActorObjectId = (log) => {
    if (!log) {
        return null;
    }

    const direct =
        log.actorObjectId ?? log.actorId ?? log.userId ?? log.userObjectId ?? log.objectId;
    if (direct) {
        return String(direct);
    }

    return readMetadataField(log.metadata, [
        "actorObjectId",
        "objectId",
        "userId",
        "userObjectId",
        "actorId",
        "adminId",
        "employeeId",
    ]);
};

export const formatActivityLogTakerEmail = (log, t) => {
    if (log?.actorEmail) {
        return log.actorEmail;
    }

    if (log?.actorRole) {
        return log.actorRole;
    }

    return t("notAvailable");
};
